<!--
 * @FileDescription: 用户列表
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
    <div class="page-container-height">
      <div class="grade-top">
        <a-range-picker :value="createtime" @change="onChangedata" class="grade-time" />
        <a-input class="market-input" v-model="keyword" placeholder="请输入用户手机号" @pressEnter="onSearch()" />
        <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
        <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
      </div>
      <div class="line"></div>
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" :scroll="{y: 'calc(100vh - 270px)' }"
        class="table-log-height" bordered rowKey="key">
        <!-- <template slot="code" slot-scope="text, record, index">
                <span class="span-title" v-if="!record.ischeck" @click="changecheck(record)">{{record.inviteCode}}</span>
                <a-input v-model="record.inviteCode" v-focus v-else @pressEnter="pressEnter(record)" placeholder="请输入邀请码"/>
            </template> -->
        <template slot="state" slot-scope="text">
          <span class="table-cir" :class="text == 0 ? '' :'table-cir-warn'"></span>
          <span v-if="text == 0"> 正常</span>
          <span v-else> 禁用</span>
        </template>
        <!-- 操作按钮添加 -->
        <template slot="operation" slot-scope="text, record">
          <span style="color: #387bfc" @click="topupChange(record)">充值零钱</span>
        </template>
      </a-table>
      <div class="line"></div>
      <div class="pagination-footer-box">
        <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
          :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
          show-size-changer show-quick-jumper />
      </div>
    </div>
  </div>
</template>
<script>
import { getPageAccount } from "@/utils/api";
import { mixins } from "@/mixins/mixins";
import recordDate from "@/mixins/shop.json";
export default {
  name: "usermanage",
  mixins: [mixins],
  data() {
    return {
      keyword: "",
      createtime: null,
      starttime: "",
      endtime: "",
      columns: [
        {
          title: "",
          dataIndex: "",
          key: "rowIndex",
          width: 70,
          align: "center",
          fixed: "left",
          customRender(t, r, index) {
            return parseInt(index) + 1;
          },
        },
        {
          title: "微信号",
          key: "wechatCode",
          dataIndex: "wechatCode",
        },
        {
          width: 120,
          title: "微信绑定",
          key: "bindWechatFlag",
          dataIndex: "bindWechatFlag",
          customRender(t, r, index) {
            if (t == 0) {
              return "否";
            } else {
              return "是";
            }
          },
        },
        {
          title: "绑定手机号",
          key: "mobile",
          dataIndex: "mobile",
        },
        {
          title: "昵称",
          key: "nickname",
          dataIndex: "nickname",
        },
        {
          title: "邀请码",
          key: "inviteCode",
          dataIndex: "inviteCode",
          width: 120,
        },
        {
          title: "注册时间",
          key: "createTime",
          dataIndex: "createTime",
          ellipsis: true,
        },
        {
          title: "最近登录时间",
          key: "lastestLoginTime",
          dataIndex: "lastestLoginTime",
          ellipsis: true,
        },
        {
          width: 120,
          title: "状态",
          dataIndex: "state",
          key: "state",
          scopedSlots: { customRender: "state" },
        },
        {
          width: 120,
          title: "操作",
          align: "center",
          dataIndex: "operation",
          ellipsis: true,
          scopedSlots: { customRender: "operation" },
        },
      ],
      dataSource: [],
    };
  },
  watch: {
    pageList: {
      handler(newValue, oldValue) {
        if (!this.isEmpty(newValue.result)) {
          this.$store.state.isLoding = false;
          this.dataSource = newValue.result.records;
          this.pagination.current = newValue.result.current;
          this.pagination.total = newValue.result.total;
          this.pagination.pageSize = newValue.result.size;
          this.pages = this.pageList.result.pages;
          this.$store.state.isLoding = false;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getmessagedata();
  },
  methods: {
    /**
     * @description: 此为方法注释（方法描述）
     */
    getmessagedata() {
      this.$store.state.isLoding = true;
      this.getPageList(
        "/mall-account/web/member/pageMemberByStoreId",
        {
          companyStoreId: this.$store.state.shopId,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          startTime: this.starttime,
          endTime: this.endtime,
          keywords: this.keyword,
        },
        {}
      );
    },
    onChangedata(date, dateString) {
      this.createtime = date;
      this.starttime = dateString[0];
      this.endtime = dateString[1];
    },
    /**
     * @description: 筛选
     */
    onSearch() {
      this.getmessagedata();
    },
    /**
     * @description: 重置
     */
    onRest() {
      this.keyword = "";
      this.createtime = null;
      this.starttime = "";
      this.endtime = "";
      this.pagination.current = 1;
      this.getmessagedata();
    },
    pressEnter(record) {
      record.ischeck = false;
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getmessagedata();
    },
    handleTableChange(current) {
      this.pagination.current = current;
      this.getmessagedata();
    },
    changecheck(record) {
      record.ischeck = true;
    },
    /**
     * 描述：去充值
     */
    topupChange(record) {
      this.$router.push({
        path: "/systemcloud/usercloud/topup?id=" + record.id,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page-container-height {
  background: #ffffff;
  .grade-top {
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    .grade-time {
      width: 260px;
      margin-right: 20px;
    }
    .market-input {
      width: 260px;
      margin-right: 10px;
    }
  }
}
.span-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
